import { connect } from 'react-redux'

import { setActiveAudio } from '../../../../common/actions/searchPage'
import { IRootState } from '../../../../common/reducers'

import AudioPlayerSmall from './audioPlayerSmall'

interface IStateProps {
  isActive: boolean
}

interface IDispatchProps {
  onPlay: () => void
}

interface IOwnProps {
  src: string
}

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  const {
    searchPage: { activeAudio }
  } = state

  return {
    isActive: ownProps.src && ownProps.src === activeAudio
  }
}

const mapDispatchToProps = (dispatch: any, ownProps: IOwnProps) => {
  return {
    onPlay: () => dispatch(setActiveAudio(ownProps.src))
  }
}

const AudioPlayerSmallContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioPlayerSmall)

export default AudioPlayerSmallContainer
